import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { AliadoSucursal } from '../_models/aliado-sucursal';
import { AliadoSucursalCupo } from '../_models/aliado-sucursal-cupo';

@Injectable({
  providedIn: 'root'
})
export class AliadoSucursalService {

  private rutServicio = AppSettings.rutServiciosALIADOS + '/api/aliadosSucursales';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as AliadoSucursal[] ) );
  }

  listadoConCampos() {
    return this.httClient.get( this.rutServicio + '/all' ).pipe( map( res => res as AliadoSucursal[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as AliadoSucursal[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as AliadoSucursal ) );
  }

  obtenerPorAliadoSucursal( idAliadoSucursal: string ) {
    return this.httClient.get( this.rutServicio + '/consolidadoPorRangoFechas/sucursal/' + idAliadoSucursal ).pipe( map( res => res as AliadoSucursalCupo[] ) );

  }

  obtenerPorAliadoSucursalPost( idAliadoSucursal: string, data: any ) {
    return this.httClient.post( this.rutServicio + '/consolidadoPorRangoFechas/sucursal/' + idAliadoSucursal, data ).pipe( map( res => res as AliadoSucursalCupo[] ) );

  }

  obtenerPorIdConCampos( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id + '/obj' ).pipe( map( res => res as AliadoSucursal ) );
  }

  obtenerPorAliado( idAliado: string ) {
    return this.httClient.get( this.rutServicio + '/aliado/' + idAliado ).pipe( map( res => res as AliadoSucursal[] ) );
  }

  obtenerPorCodigo( codigo: string, idAliado: string ) {
    return this.httClient.get( this.rutServicio + '/codigo/' + codigo + '/aliado/' + idAliado ).pipe( map( res => res as AliadoSucursal ) );
  }

  obtenerPrincipal( idAliado: string ) {
    return this.httClient.get( this.rutServicio + '/aliado/' + idAliado + '/principal' ).pipe( map( res => res as AliadoSucursal ) );
  }

  crear( aliado: AliadoSucursal ) {
    aliado.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, aliado ).pipe( map( res => res as AliadoSucursal ) );
  }

  actualizar( aliado: AliadoSucursal ) {
    aliado.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, aliado ).pipe( map( res => res as AliadoSucursal ) );
  }

  actualizarAliado( idUsuario: string, estado: boolean ) {
    return this.httClient.get( this.rutServicio + '/indicadorAliado/' + idUsuario + '/' + estado ).pipe( map( res => res as any ) );
  }

  renovarCupos() {
    return this.httClient.get( this.rutServicio + '/renovarCupoMesActual/tipoMovimiento/AUMANUAL' ).pipe( map( ( res: any ) => {
      return res as any;
    } ) );
  }
  obtenerPorCiudad(idCiudad: string) {
    return this.httClient.get(this.rutServicio + '/divisionPolitica/' + idCiudad + '/enabled').pipe(map(res => res as any[]));
  }

  obtenerSucursalesPorAliado( aliado: any ) {
    return this.httClient.post( this.rutServicio + '/aliados', aliado ).pipe( map( res => res as any[] ) );
  }

  obtenerOficinasPorAliado( aliado: any ) {
    return this.httClient.post( this.rutServicio + '/aliados/oficinas', aliado ).pipe( map( res => res as any[] ) );
  }
}
